module.exports = {"array":[{"market":"AR_es","text":{"menushowtext":"","menuhidetext":""},"onix":[{"code":"CHE-2019-10-21_INT_OnyxHB_comp_Compositing_ARG","version":"v005","default":true}]},{"market":"BR_pt","text":{"menushowtext":"","menuhidetext":""},"onix":[{"code":"CHE-2019-10-21_INT_OnyxHB_comp_Compositing_BRA","version":"v005","default":true}]}]}


//////////////////
// WEBPACK FOOTER
// ./config/config.json
// module id = J/Fn
// module chunks = 0